import React from 'react';
import './MvpCard.css';

class MvpCard extends React.PureComponent {
  render() {
    const {mvp} = this.props;
    return (
      <div className="EmbedBox EmbedBox--standardMargins">
        <div className="EmbedBox-stretchedHeader">
          <div className="text-center" style={{color: 'green', fontSize: 20, fontWeight: 'bold'}}>
            {mvp._links.game ? 'Game MVP' : 'Event MVP'}
          </div>
        </div>
        <div className="MvpCardTitle">
          <a className="MvpCardTitle-avatar" href={mvp._links.self.href}>
            <img src={mvp._links.team_member['data-avatar']} />
          </a>
          <div className="MvpCardTitle-details">
            <div className="MvpCardTitle-name">
              {mvp._links.team_member.title}
            </div>
            {mvp.event_summary}<br />
            {mvp._links.team.title}<br />
          </div>
        </div>
        <div className="SectionTitle">
          <div className="SectionTitle-tab">
            <span className="ShowcaseSectionTitle-label">Performance</span>
          </div>
          <div className="SectionTitle-sep"></div>
          <div className="SectionTitle-addl"></div>
          <div className="SectionTitle-rest"></div>
        </div>
        <p className="MvpCard-description">{mvp.description}</p>
        <p className="text-right">
          <a href={mvp._links.self.href}>
            More
          </a>
        </p>
      </div>
    );
  }
}

export default MvpCard;
